module.exports = __webpack_public_path__ + "img/BCaravan64_ua.45e0bbcc.webp";